function Header({children, logoAbsolute = false}) {
    return (
      <header id="header">
        <figure className="logo" onClick={() => window.location.href = "/"} style={logoAbsolute ? {position: "absolute"} : undefined}>
          <h1 className="brand-name">SANTANA HOT DOG</h1>
        </figure>
        <div className="header-content">{children}</div>
      </header>
    );
  }
  
export default Header;
  